import React, { useEffect } from "react";
import { Table, Tag, Card, Descriptions } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getaOrder } from "../features/auth/authSlice";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Product Name",
    dataIndex: "name",
  },
  {
    title: "Brand",
    dataIndex: "brand",
  },
  {
    title: "Count",
    dataIndex: "count",
  },
  {
    title: "Amount",
    dataIndex: "amount",
  },
  {
    title: "Product ID",
    dataIndex: "productId",
  },
  {
    title: "Type",
    dataIndex: "type",
  },
];

const ViewOrder = () => {
  const location = useLocation();
  const orderId = location.pathname.split("/")[3];
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getaOrder(orderId));
  }, []);
  const orderState = useSelector((state) => state?.auth?.singleorder?.orders);
  console.log(orderState);
  
  const data1 = [];
  for (let i = 0; i < orderState?.orderItems?.length; i++) {
    const isPreorderItem = orderState?.orderItems[i]?.isPreorder;
    
    data1.push({
      key: i + 1,
      name: orderState?.orderItems[i]?.product?.title,
      brand: orderState?.orderItems[i]?.product?.brand,
      count: orderState?.orderItems[i]?.quantity,
      amount: orderState?.orderItems[i]?.price,
      productId: orderState?.orderItems[i]?.product?.customProductId || `#${orderState?.orderItems[i]?.product?._id?.toString().slice(-8).toUpperCase()}` || "N/A",
      type: isPreorderItem ? (
        <Tag color="blue">Preorder</Tag>
      ) : (
        <Tag color="green">Regular</Tag>
      ),
    });
  }
  
  return (
    <div>
      <h3 className="mb-4 title">View Order</h3>
      
      {/* Order Information */}
      <Card title="Order Information" className="mb-4">
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Order ID">{orderState?.customOrderId || `#${orderState?._id?.slice(-8).toUpperCase()}`}</Descriptions.Item>
          <Descriptions.Item label="Order Status">
            <Tag color={orderState?.orderStatus === "Preorder" ? "blue" : "green"}>
              {orderState?.orderStatus}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Order Date">
            {orderState?.createdAt ? new Date(orderState.createdAt).toLocaleString() : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Total Amount">
            ₹{orderState?.totalPrice?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label="Total After Discount">
            ₹{orderState?.totalPriceAfterDiscount?.toLocaleString()}
          </Descriptions.Item>
          {orderState?.delhivery?.waybillNumber && (
            <Descriptions.Item label="AWB Number (Package ID)">
              {orderState?.delhivery?.waybillNumber}
            </Descriptions.Item>
          )}
        </Descriptions>
      </Card>
      
      {/* Customer Information */}
      <Card title="Customer Information" className="mb-4">
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Customer Name">
            {orderState?.user?.firstname} {orderState?.user?.lastname}
          </Descriptions.Item>
          <Descriptions.Item label="Customer Email">
            {orderState?.user?.email}
          </Descriptions.Item>
          <Descriptions.Item label="Customer Mobile">
            {orderState?.user?.mobile}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      
      {/* Shipping Address */}
      <Card title="Shipping Address" className="mb-4">
        <Descriptions bordered column={2}>
          <Descriptions.Item label="Recipient Name">
            {orderState?.shippingInfo?.firstname} {orderState?.shippingInfo?.lastname}
          </Descriptions.Item>
          <Descriptions.Item label="Address">
            {orderState?.shippingInfo?.address}
          </Descriptions.Item>
          <Descriptions.Item label="City">
            {orderState?.shippingInfo?.city}
          </Descriptions.Item>
          <Descriptions.Item label="State">
            {orderState?.shippingInfo?.state}
          </Descriptions.Item>
          <Descriptions.Item label="Pincode">
            {orderState?.shippingInfo?.pincode}
          </Descriptions.Item>
          <Descriptions.Item label="Country">
            {orderState?.shippingInfo?.country || "India"}
          </Descriptions.Item>
        </Descriptions>
      </Card>
      
      {/* Delhivery Information */}
      {orderState?.delhivery?.waybillNumber && (
        <Card title="Delhivery Information" className="mb-4">
          <Descriptions bordered column={2}>
            <Descriptions.Item label="AWB Number">
              {orderState?.delhivery?.waybillNumber}
            </Descriptions.Item>
            <Descriptions.Item label="Shipment Status">
              <Tag color={orderState?.delhivery?.status ? "blue" : "default"}>
                {orderState?.delhivery?.status || "Pending"}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Tracking URL">
              <a 
                href={orderState?.delhivery?.trackingUrl} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                View on Delhivery
              </a>
            </Descriptions.Item>
          </Descriptions>
        </Card>
      )}
      
      {/* Order Items */}
      <Card title="Order Items">
        <Table columns={columns} dataSource={data1} />
      </Card>
      
      {/* Show preorder notice if order contains preorder items */}
      {orderState?.orderStatus === "Preorder" && (
        <div className="mt-4 p-3 bg-blue-100 border border-blue-300 rounded">
          <h4 className="font-bold text-blue-800">Preorder Order</h4>
          <p className="text-blue-700">
            This order contains preorder items. Payment will be processed when items are in stock.
          </p>
        </div>
      )}
    </div>
  );
};

export default ViewOrder;